import {Component, ElementRef, ViewChild, OnInit} from '@angular/core';
import {AppConfig, LayoutService} from './service/app.layout.service';
import {AuthService} from "../_services/auth_service";
import {NavigationEnd, Router} from "@angular/router";
import {HttpResponse} from "@angular/common/http";
import {LanguageService} from "../_services/language_service";
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrl: './app.topbar.component.css',
})
export class AppTopbarComponent implements OnInit {
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

    config!: AppConfig;


    selectedLanguage: string = 'it'; // Valore di default

    subscription: any;
    public nome: string = "";
    public ruolo: string = "";
    public medico_id: string = "";
    public dashboard_link = "/";

    showDialog: boolean = false;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private authService: AuthService,
        private router: Router,
        private languageService: LanguageService
    ) {
        this.subscription = this.layoutService.configUpdate$.subscribe(
            (config) => {
                this.config = config;
            }
        );


    }
    onLanguageChange(event: Event): void {
        const lang: string = (event.target as HTMLSelectElement).value;
        this.languageService.changeLanguage(lang);
    }


    ngOnInit() {
        const savedLanguage = localStorage.getItem('lang');
        if (savedLanguage) {
            this.selectedLanguage = savedLanguage;
        }

        this.authService.getUserData().subscribe({
            next: (response: HttpResponse<any>) => {

                this.nome = response.body.nome;
                this.ruolo = response.body.ruolo;
                if (this.ruolo == 'medico') {
                    this.dashboard_link = '/medico';
                }
                if (this.ruolo == 'paziente') {
                    this.dashboard_link = '/paziente';
                }
                else {
                    this.dashboard_link = '/';
                }
            }
        });
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    dialog() {
        this.showDialog = true;
    }

    logout() {
        this.closeTopbarMenu();
        this.authService.logout().subscribe({
            next: (response: HttpResponse<any>) => {
                const statusCode = response.status;
                if (statusCode == 200) {
                    //this.router.navigate(['/login']);
                    window.location.href = 'https://doctorium.it';
                }
            },
            error: (error) => {
                //  this.messageService.add({ key: 'centerTop', severity: 'error', summary: 'Errore', detail: error.error.message, life: 3000 });
            }
        });
    }

    goToProfilo() {
        this.closeTopbarMenu();
        if (this.ruolo === 'medico') {
            this.router.navigate(['/profilomedico']);
        } else if (this.ruolo === 'paziente') {
            this.router.navigate(['/profilopaziente']);
        }

    }

    goToCambiapassword() {
        this.closeTopbarMenu();
        this.router.navigate(['/cambiapassword']);
    }

    goToModificaConsensi() {
        this.closeTopbarMenu();
        this.router.navigate(['/modificaconsensi']);
    }

    goToPreferenzeUtente() {
        this.closeTopbarMenu();
        this.router.navigate(['/preferenzeutente']);
    }

    goToPrivacyConsulto() {
        this.closeTopbarMenu();
        this.router.navigate(['/privacy-consulto']);
    }
    isInternalLink(url: string): boolean {
        return !/^https?:\/\//.test(url);  // Ritorna true se NON è un link esterno
    }

    closeTopbarMenu() {
        const menus = document.querySelectorAll('.layout-topbar-menu');
        menus.forEach((menu: any) => {
            menu.classList.add('hidden');
        });
    }

}
